module.exports = __webpack_public_path__ + "static/img/earrings_01.47b07e1.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/other/thumbnail/earrings_01.png
// module id = ue6S
// module chunks = 0